import { Button } from '@progress/kendo-react-buttons';
import { SettingsOutline } from '../../../../../icons/icons';
import { EventBus } from '../../../../contexts/event-bus';

const DashboardSettingsToolbarItem = () => {
    return (
        <Button
            type="button"
            data-tooltip-bottom
            title="Dashboard settings"
            aria-label="Show dashboard settings"
            svgIcon={SettingsOutline}
            style={{ width: 27, height: 27 }}
            className="k-rounded-full"
            onClick={() => EventBus.fire('dashboard-settings-open', null)}
        />
    );
};

export default DashboardSettingsToolbarItem;
